import { render, staticRenderFns } from "./ResizableTextarea.vue?vue&type=template&id=143cd961&scoped=true&"
import script from "./ResizableTextarea.vue?vue&type=script&lang=js&"
export * from "./ResizableTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ResizableTextarea.vue?vue&type=style&index=0&id=143cd961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143cd961",
  null
  
)

export default component.exports